export function parseCoordinates(
  input: string
): { lat: number; lng: number } | null {
  input = input.trim();

  // --- Case 1: decimal coordinates ---
  // Support: "49.813608, 30.116710", "49.813608 30.116710", "49.813608;30.116710"
  const decimalMatch = input.match(/^(-?\d+(\.\d+)?)[,\s;]+(-?\d+(\.\d+)?)/);
  if (decimalMatch) {
    return {
      lat: parseFloat(decimalMatch[1]),
      lng: parseFloat(decimalMatch[3]),
    };
  }

  // --- Case 2: DMS format ---
  // Support: "49°48'49.0\"N 30°07'00.2\"E"
  const dmsRegex =
    /(\d+)[°]\s*(\d+)'?\s*(\d+(?:\.\d+)?)?"?\s*([NS])[\s,;]+(\d+)[°]\s*(\d+)'?\s*(\d+(?:\.\d+)?)?"?\s*([EW])/i;
  const dmsMatch = input.match(dmsRegex);
  if (dmsMatch) {
    const lat = convertDMSToDD(
      +dmsMatch[1],
      +dmsMatch[2],
      +dmsMatch[3],
      dmsMatch[4].toUpperCase()
    );
    const lng = convertDMSToDD(
      +dmsMatch[5],
      +dmsMatch[6],
      +dmsMatch[7],
      dmsMatch[8].toUpperCase()
    );
    return { lat, lng };
  }

  // --- Case 3: decimal coordinates with directions ---
  // Support: "49.813608N 30.116710E" или "49.813608 S, 30.116710 W"
  const decimalDirRegex =
    /^(-?\d+(\.\d+)?)([NSns])?[,\s;]+(-?\d+(\.\d+)?)([EWew])?$/;
  const decimalDirMatch = input.match(decimalDirRegex);
  if (decimalDirMatch) {
    let lat = parseFloat(decimalDirMatch[1]);
    let lng = parseFloat(decimalDirMatch[4]);
    const latDir = decimalDirMatch[3]?.toUpperCase();
    const lngDir = decimalDirMatch[6]?.toUpperCase();
    if (latDir === "S") lat *= -1;
    if (lngDir === "W") lng *= -1;
    return { lat, lng };
  }

  return null;
}

function convertDMSToDD(
  deg: number,
  min: number,
  sec: number,
  dir: string
): number {
  let dd = deg + min / 60 + sec / 3600;
  if (dir === "S" || dir === "W") dd *= -1;
  return dd;
}
